<template>
  <div>
    <el-tabs v-model="activatedTabName">
      <el-tab-pane label="环境" name="environment">
        <EnvironmentListPage v-if="activatedTabName == 'environment'"></EnvironmentListPage>
      </el-tab-pane>
      <el-tab-pane label="强更新" name="forceUpdate">
        <ForceUpdateConfigPage v-if="activatedTabName == 'forceUpdate'"></ForceUpdateConfigPage>
      </el-tab-pane>
      <el-tab-pane label="热更新" name="hotUpdate">
        <HotUpdateConfigListPage v-if="activatedTabName == 'hotUpdate'"></HotUpdateConfigListPage>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EnvironmentListPage from "./tab-pages/EnvironmentListPage";
import ForceUpdateConfigPage from "./tab-pages/ForceUpdateConfigPage";
import HotUpdateConfigListPage from "./tab-pages/HotUpdateConfigListPage";

export default {
  data() {
    return {
      activatedTabName: "environment",
    };
  },

  components: {
    EnvironmentListPage,
    ForceUpdateConfigPage,
    HotUpdateConfigListPage,
  },
};
</script>